import deep from 'deep-get-set';
import { createSelector } from 'reselect';
import { createAction } from 'redux-api-middleware';
import config from '../../config';
import { buildHeaders } from '../buildAuthHeader';

// Actions
export const PLUGIN_MEDIA_SELECT = 'PLUGIN_MEDIA_SELECT';
export const PLUGIN_MEDIA_DESELECT = 'PLUGIN_MEDIA_DESELECT';
export const MEDIA_SELECTION_CLEAR = 'MEDIA_SELECTION_CLEAR';
export const MEDIA_SELECTION_SELECT_ALL = 'MEDIA_SELECTION_SELECT_ALL';
export const PLUGIN_CHOICE_MODAL_SHOW = 'PLUGIN_CHOICE_MODAL_SHOW';
export const PLUGIN_CHOICE_MODAL_HIDE = 'PLUGIN_CHOICE_MODAL_HIDE';
export const PLUGIN_CREATE_LOAD = 'PLUGIN_CREATE_LOAD';
export const PLUGIN_CREATE_LOAD_SUCCESS = 'PLUGIN_CREATE_LOAD_SUCCESS';
export const PLUGIN_CREATE_LOAD_FAILURE = 'PLUGIN_CREATE_LOAD_FAILURE';
export const PLUGIN_INFORMATION_LOAD = 'PLUGIN_INFORMATION_LOAD';
export const PLUGIN_INFORMATION_LOAD_FAILURE = 'PLUGIN_INFORMATION_LOAD_FAILURE';
export const PLUGIN_INFORMATION_LOAD_SUCCESS = 'PLUGIN_INFORMATION_LOAD_SUCCESS';
export const PUBLISHED_PLUGIN_INFORMATION_LOAD = 'PUBLISHED_PLUGIN_INFORMATION_LOAD';
export const PUBLISHED_PLUGIN_INFORMATION_LOAD_FAILURE =
  'PUBLISHED_PLUGIN_INFORMATION_LOAD_FAILURE';
export const PUBLISHED_PLUGIN_INFORMATION_LOAD_SUCCESS =
  'PUBLISHED_PLUGIN_INFORMATION_LOAD_SUCCESS';
export const MEDIA_SORT_ORDER_SET = 'MEDIA_SORT_ORDER_SET';
export const VIDEOPEEL_LOGO_SHOW_SET = 'VIDEOPEEL_LOGO_SHOW_SET';
export const PLUGIN_UPDATE_LOAD = 'PLUGIN_UPDATE_LOAD';
export const PLUGIN_UPDATE_LOAD_FAILURE = 'PLUGIN_UPDATE_LOAD_FAILURE';
export const PLUGIN_UPDATE_LOAD_SUCCESS = 'PLUGIN_UPDATE_LOAD_SUCCESS';
export const PLUGIN_PUBLISH_LOAD = 'PLUGIN_PUBLISH_LOAD';
export const PLUGIN_PUBLISH_LOAD_FAILURE = 'PLUGIN_PUBLISH_LOAD_FAILURE';
export const PLUGIN_PUBLISH_LOAD_SUCCESS = 'PLUGIN_PUBLISH_LOAD_SUCCESS';
export const PLUGIN_LIST_LOAD = 'PLUGIN_LIST_LOAD';
export const PLUGIN_LIST_LOAD_FAILURE = 'PLUGIN_LIST_LOAD_FAILURE';
export const PLUGIN_LIST_LOAD_SUCCESS = 'PLUGIN_LIST_LOAD_SUCCESS';
export const PLUGIN_DELETE_MODAL_SHOW = 'PLUGIN_DELETE_MODAL_SHOW';
export const PLUGIN_DELETE_MODAL_HIDE = 'PLUGIN_DELETE_MODAL_HIDE';
export const PLUGIN_DELETE_LOAD = 'PLUGIN_DELETE_LOAD';
export const PLUGIN_DELETE_LOAD_FAILURE = 'PLUGIN_DELETE_LOAD_FAILURE';
export const PLUGIN_DELETE_LOAD_SUCCESS = 'PLUGIN_DELETE_LOAD_SUCCESS';
export const SELECTED_MEDIA_UPDATE = 'SELECTED_MEDIA_UPDATE';
export const PLUGIN_CREATE_ERROR_CLEAR = 'PLUGIN_CREATE_ERROR_CLEAR';
export const PLUGIN_UPDATE_ERROR_CLEAR = 'PLUGIN_UPDATE_ERROR_CLEAR';
export const MEDIA_SELECTION_CANCEL = 'MEDIA_SELECTION_CANCEL';

// Action Creators
export function selectMedia(mediaId, allMediaIds) {
  return {
    type: PLUGIN_MEDIA_SELECT,
    payload: mediaId,
    allMediaIds
  };
}

export function deSelectMedia(mediaId, allMediaIds) {
  return {
    type: PLUGIN_MEDIA_DESELECT,
    payload: mediaId,
    allMediaIds
  };
}

export function clearMediaSelection() {
  return {
    type: MEDIA_SELECTION_CLEAR
  };
}

export function selectAllMedia(allMedia) {
  return {
    type: MEDIA_SELECTION_SELECT_ALL,
    payload: allMedia
  };
}

export function cancelMediaSelection() {
  return {
    type: MEDIA_SELECTION_CANCEL
  };
}

export function showPluginChoiceModal() {
  return {
    type: PLUGIN_CHOICE_MODAL_SHOW
  };
}

export function hidePluginChoiceModal() {
  return {
    type: PLUGIN_CHOICE_MODAL_HIDE
  };
}

export const createNewPlugin = (payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.createPlugin}`,
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
    types: [PLUGIN_CREATE_LOAD, PLUGIN_CREATE_LOAD_SUCCESS, PLUGIN_CREATE_LOAD_FAILURE]
  });

export const fetchPluginList = () =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.pluginDetails}`,
    headers: buildHeaders(),
    method: 'GET',
    credentials: 'include',
    types: [PLUGIN_LIST_LOAD, PLUGIN_LIST_LOAD_SUCCESS, PLUGIN_LIST_LOAD_FAILURE]
  });

export const fetchPluginDetails = (id) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.pluginDetails}/${id}/preview`,
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
    types: [
      PLUGIN_INFORMATION_LOAD,
      PLUGIN_INFORMATION_LOAD_SUCCESS,
      PLUGIN_INFORMATION_LOAD_FAILURE
    ]
  });

export const fetchPublishedPluginDetails = (id) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.pluginDetails}/${id}`,
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
    types: [
      PUBLISHED_PLUGIN_INFORMATION_LOAD,
      PUBLISHED_PLUGIN_INFORMATION_LOAD_SUCCESS,
      PUBLISHED_PLUGIN_INFORMATION_LOAD_FAILURE
    ]
  });

export const updatePlugin = (id, payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.createPlugin}/${id}/preview`,
    method: 'PUT',
    credentials: 'include',
    headers: buildHeaders(),
    body: JSON.stringify(payload),
    types: [PLUGIN_UPDATE_LOAD, PLUGIN_UPDATE_LOAD_SUCCESS, PLUGIN_UPDATE_LOAD_FAILURE]
  });

export const publishPlugin = (id, payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.createPlugin}/${id}`,
    method: 'PUT',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(payload),
    types: [PLUGIN_PUBLISH_LOAD, PLUGIN_PUBLISH_LOAD_SUCCESS, PLUGIN_PUBLISH_LOAD_FAILURE]
  });

export const deletePlugin = (id) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.pluginDetails}/${id}`,
    headers: buildHeaders(),
    method: 'DELETE',
    credentials: 'include',
    types: [PLUGIN_DELETE_LOAD, PLUGIN_DELETE_LOAD_SUCCESS, PLUGIN_DELETE_LOAD_FAILURE]
  });

export function setMediaSortOrder(order) {
  return {
    type: MEDIA_SORT_ORDER_SET,
    payload: order
  };
}

export function setVidePeelLogoShow(status) {
  return {
    type: VIDEOPEEL_LOGO_SHOW_SET,
    payload: status
  };
}

export function hidePluginDeleteModal() {
  return {
    type: PLUGIN_DELETE_MODAL_HIDE
  };
}

export function showPluginDeleteModal(idToDelete) {
  return {
    type: PLUGIN_DELETE_MODAL_SHOW,
    payload: idToDelete
  };
}

export function updateSelectedMedia() {
  return {
    type: SELECTED_MEDIA_UPDATE
  };
}

export function clearPluginCreateError() {
  return {
    type: PLUGIN_CREATE_ERROR_CLEAR
  };
}

export function clearPluginUpdateError() {
  return {
    type: PLUGIN_UPDATE_ERROR_CLEAR
  };
}

// Initial State
const initialState = {
  selectedMedia: [],
  isAllMediaSelected: false,
  shouldShowPluginChoiceModal: false,
  shouldShowPluginDeleteModal: false,
  createdPluginId: null,
  idToDelete: null,
  isUpdatingMedia: false, // for editing existing plugins
  pluginSettings: {},
  publishedSettings: {},
  isCreatingPlugin: false,
  hasPluginCreationFailure: false,
  hasPluginUpdateFailure: false,
  hasPluginInformationLoadFailure: false,
  pluginCreationFailureMessage: null,
  isUpdatingPlugin: false,
  isFetchingPluginData: false,
  settingsAreDirty: false,
  settingsVaryFromPublished: false,
  meta: {},
  data: [],
  isLoadingList: false,
  hasListLoadFailure: false,
  listLoadError: ''
};

// Reducer helpers
function settingsAreNotEqual(published, current) {
  // If either object is empty, return true
  // This bails us out of erroring out while
  // one endpoint is fetching and the other has
  // not yet returned
  if (Object.keys(published).length === 0) {
    return true;
  }

  if (Object.keys(current).length === 0) {
    return true;
  }

  const publishedIds = published.content.map((m) => m.id);
  const publishedIdSet = new Set(publishedIds);
  const currentIds = current.content.map((m) => m.id);
  const currentIdSet = new Set(currentIds);

  // Check anything that we care about
  // that could differ between two objects
  if (published.sortOrder !== current.sortOrder) {
    return true;
  }

  if (published.showVideoPeelLogo !== current.showVideoPeelLogo) {
    return true;
  }

  for (let id of currentIds) {
    if (!publishedIdSet.has(id)) {
      return true;
    }
  }

  for (let id of publishedIds) {
    if (!currentIdSet.has(id)) {
      return true;
    }
  }

  return false;
}

function allMediaIsSelected(allMediaIds, selectedIds) {
  const selectedMediaSet = new Set(selectedIds);

  for (let id of allMediaIds) {
    if (!selectedMediaSet.has(id)) {
      return false;
    }
  }

  return true;
}

// Reducers
export function pluginCreationReducer(state = initialState, action = {}) {
  switch (action.type) {
    // This code clears out the plugin editing state when changing to a route that isn't the plugin editing page, UNLESS:
    // 1 - Navigating to the Submissions or Media page for plugin creation or editing
    //     (changingRouteFrom === 'MEDIA_PAGE_PLUGIN_UPDATE')
    // 2 - Changing route due to pagination changes on the submissions/media page
    case '@@router/LOCATION_CHANGE': {
      const changingRouteFrom = action?.payload?.state?.from;
      const changingRouteTo = action?.payload?.pathname;

      const isMediaPage = (route) => route === '/media';
      const isPluginEditPage = (route) => route.startsWith('/plugins/');

      const isAddingRemovingVideos =
        changingRouteFrom === 'MEDIA_PAGE_PLUGIN_UPDATE' ||
        changingRouteFrom === 'MEDIA_PAGE_PLUGIN_CREATE' ||
        changingRouteFrom === 'PAGINATION_CHANGE';

      const shouldClearPluginEditState =
        !isAddingRemovingVideos &&
        !isPluginEditPage(changingRouteTo) &&
        !isMediaPage(changingRouteTo);

      const newState = {
        ...state,
        createdPluginId: null,
        pluginSettings: {},
        publishedSettings: {}
      };

      return shouldClearPluginEditState ? newState : state;
    }
    case PLUGIN_MEDIA_SELECT: {
      const newState = {
        ...state,
        selectedMedia: state.selectedMedia.concat(action.payload),
        isAllMediaSelected: allMediaIsSelected(
          action.allMediaIds,
          state.selectedMedia.concat(action.payload)
        )
      };

      return newState;
    }

    case PLUGIN_MEDIA_DESELECT: {
      const newState = {
        ...state,
        selectedMedia: state.selectedMedia.filter((id) => id !== action.payload),
        isAllMediaSelected: allMediaIsSelected(
          action.allMediaIds,
          state.selectedMedia.filter((id) => id !== action.payload)
        )
      };

      return newState;
    }

    case MEDIA_SELECTION_CLEAR: {
      const newState = {
        ...state,
        selectedMedia: [],
        isAllMediaSelected: false
      };

      return newState;
    }

    case MEDIA_SELECTION_SELECT_ALL: {
      const newState = {
        ...state,
        selectedMedia: action.payload,
        isAllMediaSelected: true
      };

      return newState;
    }

    case MEDIA_SELECTION_CANCEL: {
      const newState = {
        ...state,
        isUpdatingMedia: false
      };

      return newState;
    }

    case PLUGIN_CHOICE_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowPluginChoiceModal: false
      };

      return newState;
    }

    case PLUGIN_CHOICE_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowPluginChoiceModal: true
      };

      return newState;
    }

    case PLUGIN_CREATE_LOAD: {
      const newState = {
        ...state,
        isCreatingPlugin: true
      };

      return newState;
    }

    case PLUGIN_CREATE_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isCreatingPlugin: false,
        createdPluginId: action.payload.id,
        pluginSettings: action.payload,
        selectedMedia: [], // zero out selected media in case we navigate back to /media
        isAllMediaSelected: false
      };

      return newState;
    }

    case PLUGIN_CREATE_LOAD_FAILURE: {
      const newState = {
        ...state,
        isCreatingPlugin: false,
        hasPluginCreationFailure: true,
        pluginCreationFailureMessage: action.payload.message
      };

      return newState;
    }

    case PLUGIN_CREATE_ERROR_CLEAR: {
      const newState = {
        ...state,
        hasPluginCreationFailure: false,
        pluginCreationFailureMessage: null
      };

      return newState;
    }

    case PLUGIN_INFORMATION_LOAD: {
      const newState = {
        ...state,
        isFetchingPluginData: true,
        createdPluginId: null
      };

      return newState;
    }

    case PLUGIN_INFORMATION_LOAD_FAILURE: {
      const newState = {
        ...state,
        isFetchingPluginData: false,
        hasPluginInformationLoadFailure: true
      };

      return newState;
    }

    case PLUGIN_INFORMATION_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isFetchingPluginData: false,
        pluginSettings: action.payload,
        hasPluginInformationLoadFailure: false,
        selectedMedia: [],
        isAllMediaSelected: false,
        settingsVaryFromPublished: settingsAreNotEqual(state.publishedSettings, action.payload)
      };

      return newState;
    }

    case PUBLISHED_PLUGIN_INFORMATION_LOAD_SUCCESS: {
      const newState = {
        ...state,
        publishedSettings: action.payload,
        settingsVaryFromPublished: settingsAreNotEqual(action.payload, state.pluginSettings)
      };

      return newState;
    }

    case MEDIA_SORT_ORDER_SET: {
      const newState = {
        ...state,
        settingsAreDirty: true,
        pluginSettings: {
          ...state.pluginSettings,
          sortOrder: action.payload
        }
      };

      return newState;
    }

    case VIDEOPEEL_LOGO_SHOW_SET: {
      const newState = {
        ...state,
        settingsAreDirty: true,
        pluginSettings: {
          ...state.pluginSettings,
          showVideoPeelLogo: action.payload
        }
      };

      return newState;
    }

    case PLUGIN_UPDATE_LOAD: {
      const newState = {
        ...state,
        isUpdatingPlugin: true
      };

      return newState;
    }

    case PLUGIN_UPDATE_LOAD_FAILURE: {
      const newState = {
        ...state,
        isUpdatingPlugin: false,
        hasPluginUpdateFailure: true
      };

      return newState;
    }

    case PLUGIN_UPDATE_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isUpdatingPlugin: false,
        pluginSettings: action.payload,
        settingsVaryFromPublished: settingsAreNotEqual(state.publishedSettings, action.payload),
        settingsAreDirty: false,
        isUpdatingMedia: false,
        selectedMedia: [],
        isAllMediaSelected: false
      };

      return newState;
    }

    case PLUGIN_UPDATE_ERROR_CLEAR: {
      const newState = {
        ...state,
        hasPluginUpdateFailure: false
      };

      return newState;
    }

    case PLUGIN_PUBLISH_LOAD_SUCCESS: {
      const newState = {
        ...state,
        publishedSettings: action.payload,
        settingsVaryFromPublished: settingsAreNotEqual(action.payload, state.pluginSettings)
      };

      return newState;
    }

    case PLUGIN_LIST_LOAD: {
      const newState = {
        ...state,
        data: [],
        meta: {},
        isLoadingList: true
      };

      return newState;
    }

    case PLUGIN_LIST_LOAD_SUCCESS: {
      const newState = {
        ...state,
        data: action.payload.records,
        meta: action.payload.recordMetadata,
        isLoadingList: false
      };

      return newState;
    }

    case PLUGIN_DELETE_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowPluginDeleteModal: true,
        idToDelete: action.payload
      };

      return newState;
    }

    case PLUGIN_DELETE_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowPluginDeleteModal: false,
        idToDelete: null
      };

      return newState;
    }

    case SELECTED_MEDIA_UPDATE: {
      const newState = {
        ...state,
        // Repopulate the selectedMedia array with values from the
        // pluginSettings.content array
        selectedMedia: state.pluginSettings.content.map((m) => m.id),
        isUpdatingMedia: true
      };

      return newState;
    }

    // THIS ACTION is defined in media.js
    // it's possible we could import that constant
    // and use that instead. Or, it could cause
    // a very messy circular dependency
    case 'MEDIA_SUBMISSIONS_LOAD_SUCCESS': {
      const newState = {
        ...state,
        isAllMediaSelected: allMediaIsSelected(
          action.payload.data.map((m) => m.mediaId),
          state.selectedMedia
        )
      };

      return newState;
    }

    default:
      return state;
  }
}

// Selectors
export const getPluginCreationState = createSelector(
  (state) => state,
  (state) => state.get('pluginCreation')
);

export const getSelectedMedia = createSelector(
  getPluginCreationState,
  (state) => state.selectedMedia
);

export const getIsMediaSelected = createSelector(
  (state) => getSelectedMedia(state),
  (state, mediaId) => mediaId,
  (selectedMedia, mediaId) => selectedMedia.includes(mediaId)
);

export const getShouldShowCreatePluginButton = createSelector(
  getSelectedMedia,
  (selectedMedia) => selectedMedia.length !== 0
);

export const getIsCreatingPlugin = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isCreatingPlugin')
);

export const getShouldShowPluginChoiceModal = createSelector(
  getPluginCreationState,
  (state) => state.shouldShowPluginChoiceModal
);

export const getPluginPayload = createSelector(getPluginCreationState, (state) => {
  const settings = deep(state, 'pluginSettings') || {};
  const payload = {
    ...settings,
    content: settings?.content?.map((s) => s.id) || []
  };

  return payload;
});

export const getCreatedPluginId = createSelector(
  getPluginCreationState,
  (state) => deep(state, 'createdPluginId') || null
);

export const getPluginName = createSelector(
  getPluginCreationState,
  (state) => deep(state, 'pluginSettings.name') || null
);
export const getPluginType = createSelector(
  getPluginCreationState,
  (state) => deep(state, 'pluginSettings.type') || null
);

export const getSortOrder = createSelector(
  getPluginCreationState,
  (state) => deep(state, 'pluginSettings.sortOrder') || null
);

export const getShouldShowVideoPeelLogo = createSelector(getPluginCreationState, (state) =>
  deep(state, 'pluginSettings.showVideoPeelLogo')
);

export const getIsFetchingPluginData = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isFetchingPluginData')
);

export const getIsUpdatingPlugin = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isUpdatingPlugin')
);

export const getAreSettingsDirty = createSelector(getPluginCreationState, (state) =>
  deep(state, 'settingsAreDirty')
);

export const getSettingsDifferFromPublished = createSelector(getPluginCreationState, (state) =>
  deep(state, 'settingsVaryFromPublished')
);

export const getPluginId = createSelector(
  getPluginCreationState,
  (state) => deep(state, 'pluginSettings.id') || null
);

export const getIsLoadingList = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isLoadingList')
);

export const getPluginListData = createSelector(getPluginCreationState, (state) =>
  deep(state, 'data')
);

export const getShouldShowPluginDeleteModal = createSelector(getPluginCreationState, (state) =>
  deep(state, 'shouldShowPluginDeleteModal')
);

export const getIdToDelete = createSelector(getPluginCreationState, (state) =>
  deep(state, 'idToDelete')
);

export const getIsUpdatingSelectedMedia = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isUpdatingMedia')
);

export const getHasPluginCreationFailure = createSelector(getPluginCreationState, (state) =>
  deep(state, 'hasPluginCreationFailure')
);

export const getHasPluginUpdateFailure = createSelector(getPluginCreationState, (state) =>
  deep(state, 'hasPluginUpdateFailure')
);

export const getHasPluginInformationLoadFailure = createSelector(getPluginCreationState, (state) =>
  deep(state, 'hasPluginInformationLoadFailure')
);

export const getIsAllMediaSelected = createSelector(getPluginCreationState, (state) =>
  deep(state, 'isAllMediaSelected')
);

export const getCurrentPluginContent = createSelector(getPluginCreationState, (state) =>
  deep(state, 'pluginSettings.content')
);

export const getCurrentPluginInfo = createSelector(getPluginCreationState, (state) =>
  deep(state, 'pluginSettings')
);



// WEBPACK FOOTER //
// ./src/redux/modules/pluginCreation.js